import api from "../../services/api";

const useDashboardAuditor = () => {

    const find = async (params) => {
        const { data } = await api.request({
            url: `/dashboardAuditor`,
            method: 'GET',
            params
        });
        return data;
    }

    return {
        find
    }
}

export default useDashboardAuditor;